import React, { PropsWithChildren } from "react";

import { useRadiusSize } from "arkh";
import { useWidgetLayout } from "../WidgetLayoutContext";

export const WebPageWrapper = ({
  children,
  active,
}: PropsWithChildren<{ active: boolean }>) => {
  const { width, height } = useWidgetLayout();

  const borderRadius = useRadiusSize("medium");
  return (
    <div
      style={{
        width,
        height,
        borderRadius,
        position: "absolute",
        top: 0,
        left: 0,
        display: "flex",
        overflow: "hidden",
        transition: ".3s opacity",
        opacity: active ? 1 : 0,
        willChange: "opacity",
      }}
    >
      {children}
    </div>
  );
};
